$(document).ready(function () {

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *

    // var $heroSlider = $(".hero__slider");
    // if ($heroSlider.length) {
    //     $heroSlider.bxSlider({
    //         mode: 'fade',
    //         touchEnabled: false,
    //         captions: true,
    //         pager: ($(".hero__slider .hero__slide").length > 1) ? true : false,
    //         controls: false,
    //         auto: true,
    //         speed: 800,
    //         pause: 10000,
    //         autoHover: true
    //     });
    // }

    // Select the heroSlider
    const heroSlider = document.getElementsByClassName('js-hero-slider');
    
    // Check if heroSlider were found
    if (heroSlider !== null) {

        // Loop through each element with class "js-hero-slider'"
        for (let i = 0; i < heroSlider.length; i++) {
            new Splide(heroSlider[i], {
                type            : 'fade',
                autoplay        : true,
                speed           : 800,
                interval        : 10000,
                arrows          : false,
                pagination      : true,
                pauseOnHover    : true,
                rewind          : true,
                lazyLoad        : 'nearby'
            }).mount();
        }
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * highlightSlider
    // *
    // *

    // var $highlightSlider = $(".highlights__slider");
    // if ($highlightSlider.length) {
    //     $highlightSlider.bxSlider({
    //         mode: 'fade',
    //         touchEnabled: false,
    //         captions: true,
    //         pager: ($(".highlights__slider .highlights__slide").length > 1) ? true : false,
    //         controls: false
    //     });
    // }

    // Select the textSlider
    const highlightSlider = document.getElementsByClassName('js-highlight-slider');
    console.log(highlightSlider);

    // Check if imageSlider were found
    if (highlightSlider !== null) {
        for (let i = 0; i < highlightSlider.length; i++) {
            new Splide(highlightSlider[i], {
                type            : 'fade',
                rewind          : true,
                arrows          : false,
                pagination      : true,
                lazyLoad        : 'nearby',
                perPage         : 1
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * blogSlider
    // *
    // *

    // var $blogSlider = $(".blogList__slider");
    // if ($blogSlider.length) {
    //     $blogSlider.bxSlider({
    //         mode: 'horizontal',
    //         touchEnabled: false,
    //         captions: true,
    //         pager: false,
    //         controls: ($(".blogList__slider .blogList__slide").length > 1) ? true : false,
    //         minSlides: 1,
    //         maxSlides: 3,
    //         moveSlides: 1,
    //         slideWidth: '486',
    //         slideMargin: 0,
    //         shrinkItems: true,
    //         adaptiveHeight: false,
    //         //startSlide: 1,
    //         //assets/templates/dornbach/
    //         nextText: '<svg class="bxslider-next-svg"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/templates/dornbach/img/sprite.svg#angle-right"></use></svg>',
    //         prevText: '<svg class="bxslider-prev-svg"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/templates/dornbach/img/sprite.svg#angle-left"></use></svg>',
        
    //         onSliderLoad: function () {
    //             $('.blogList__slider>li:not(.bx-clone)').eq(1).addClass('active-slide');
    //         },
    //         onSlideBefore: function ($slideElement, oldIndex, newIndex) {
    //             $('.blogList__slide').removeClass('active-slide');
    //             $($slideElement).next().addClass('active-slide');        
    //         }
    //     });

    //     $(window).on('load resize', function () {
    //         if (window.innerWidth < 767) {
    //             $blogSlider.reloadSlider({
    //                 mode: 'horizontal',
    //                 touchEnabled: true,
    //                 slideWidth: '767',
    //                 maxSlides: 1,
    //                 adaptiveHeight: true,
    //                 pager: false,
    //                 nextText: '<svg class="bxslider-next-svg"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/templates/dornbach/img/sprite.svg#angle-right"></use></svg>',
    //                 prevText: '<svg class="bxslider-prev-svg"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/templates/dornbach/img/sprite.svg#angle-left"></use></svg>',

    //             });
    //         }
    //     });
    // }

    const blogSlider = document.getElementsByClassName('js-blog-slider');

    if (blogSlider.length > 0) {
        for (let i = 0; i < blogSlider.length; i++) {
            const splide = new Splide(blogSlider[i], {
                type         : 'loop',
                arrows       : true,
                pagination   : true,
                pauseOnHover : true,
                rewind       : true,
                perPage      : 3,
                perMove      : 1,
                focus        : 'center',
                interval     : 8000,
                lazyLoad     : 'nearby',
                breakpoints: {
                    768: {
                        perPage: 1,
                        focus: '',
                    },
                    1024: {
                        perPage: 2,
                        focus: '',
                    },
                }
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * textSlider
    // *
    // *

    // var $textSlider = $(".textSlider__slider");
    // if ($textSlider.length) {
    //     $textSlider.bxSlider({
    //         mode: 'fade',
    //         touchEnabled: false,
    //         captions: true,
    //         pager: ($(".textSlider__slider .textSlider__slide").length > 1) ? true : false,
    //         controls: false
    //     });
    // }

    // Select the textSlider
    const textSlider = document.getElementsByClassName('js-text-slider');
    console.log(textSlider);

    // Check if imageSlider were found
    if (textSlider !== null) {
        for (let i = 0; i < textSlider.length; i++) {
            new Splide(textSlider[i], {
                type            : 'fade',
                rewind          : true,
                arrows          : false,
                pagination      : true,
                lazyLoad        : 'nearby',
                perPage         : 1,
                gap             : '3rem'
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll to top
    // *
    // *

    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.scrolltotop').fadeIn();
        } else {
            $('.scrolltotop').fadeOut();
        }
    });

    $('.scrolltotop').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page

    $(".hero__scrolldownlink").click(function () {
        $('html, body').animate({
            scrollTop: $(this).offset().top - 80
        }, 1000);
        return false;
    });

    $(".scrolldownlink").on('click', function (e) {
        var href = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(href).offset().top - 80
        }, 1000);
        e.preventDefault();
    });

    $(".subnavAnchorLink, .anchor__link").on('click', function (e) {
        var getName = $(this).attr('href').split('#');
        $('html,body').animate({ scrollTop: $('a[name =' + getName[1] + ']').offset().top - 110 }, 1000);
        e.preventDefault();
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Link in a new window
    // *
    // *

    $('a[rel*="external"]').click(function () {
        $(this).attr('target', '_blank');
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accodion
    // *
    // *

    $('.accordion__title').click(function () {
        $(this).toggleClass('open');
        $accordion_content = $(this).next('.accordion__content');
        $('.accordion__content').not($accordion_content).slideUp(200);
        $('.accordion__content').not($accordion_content).prev('.accordion__title').removeClass('open');
        $accordion_content.stop(true, true).slideToggle(200);
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hash scrollto
    // *
    // *

    $(window).on('load', function () {
        var myhash = window.location.hash;
        if ((myhash.length != "") && (myhash.substring(1, 4) != "tab") && (myhash.substring(1, 12) != "kontaktdaten")) {
            var name = "#my" + myhash.slice(1);
            $("body,html").animate({ scrollTop: $(name).offset().top }, 1200);
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * search and language overlay
    // *
    // *

    // $(".search__btn").click(function () {
    //     $(".language").removeClass("active");
    //     $(".search").toggleClass("active");
    // });

    // $(".language__btn").click(function () {
    //     $(".search").removeClass("active");
    //     $(".language").toggleClass("active");
    // });

    // Such-Overlay öffnen/schließen
    $(".search__btn").click(function () {
        // Sprachbereich deaktivieren
        $(".language").removeClass("active");
        $(".language__btn").attr("aria-expanded", "false");
        $("#language-panel").prop("hidden", true);
        $("#language-panel").attr("aria-hidden", "true");

        $(".search").toggleClass("active");
        const isActive = $(".search").hasClass("active");
        $(".search__btn").attr("aria-expanded", isActive);
        $("#search-panel").prop("hidden", !isActive);
        $("#search-panel").attr("aria-hidden", !isActive);

        // Fokusfähigkeit innerhalb deaktivieren/aktivieren
        $("#search-panel input, #search-panel button").attr("tabindex", isActive ? "0" : "-1");
    });


    // Sprach-Overlay öffnen/schließen
    $(".language__btn").click(function () {
        $(".search").removeClass("active");
        $(".search__btn").attr("aria-expanded", "false");
        $("#search-panel").prop("hidden", true);
        $("#search-panel").attr("aria-hidden", "true");
        $("#search-panel input, #search-panel button").attr("tabindex", "-1");

        $(".language").toggleClass("active");
        const isActive = $(".language").hasClass("active");
        $(".language__btn").attr("aria-expanded", isActive);
        $("#language-panel").prop("hidden", !isActive);
        $("#language-panel").attr("aria-hidden", !isActive);
        $("#language-panel a").attr("tabindex", isActive ? "0" : "-1");
    });






    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Overlay Navigation
    // *
    // *

    $('.hamburger').click(function () {
        if ($('.hamburger__button').hasClass("close")) {
            $(".header__nav").removeClass("open");
            $('.hamburger__button').removeClass("close");
        }
        else {
            $(".header__nav").addClass("open");
            $('.hamburger__button').addClass("close");
        }
    });



    /// * * * * * * * * * * * * * * * * * * * * * * * * *
    // * mixitup with callback for lazyload
    // *
    // *

    var containerEl = document.querySelector('.shuffle__list');
    var inputSearch = document.getElementById("inputSearch");

    if ($(containerEl).length) {
        var mixer = mixitup(containerEl, {
            multifilter: {
                enable: true
            },
            animation: {
                effects: 'fade translateZ(-100px)'
            },
            callbacks: {
                onMixStart: function (state, futureState) {
                    $('.lazy').lazy({ bind: "event", delay: 0 });
                },
                onMixEnd: function (state) {
                    shuffleToggleFilter();
                },
                onMixClick: function () {
                    // reset the search if a filter is clicked
                    if ($(inputSearch).length) {
                        if (this.matches("[data-name]")) {
                            inputSearch.value = "";
                        }
                    }
                }
            }
        });
    }

    if ($(inputSearch).length) {
        inputSearch.addEventListener("keyup", function(event) {
            if (inputSearch.value.length < 1) {
                searchValue = "";
            } else {
                return searchValue = inputSearch.value.replace(/[!\"#$%&'\(\)\*\+,\.\/:;<=>\?\@\[\\\]\^`\{\|\}~]/g, '')
                .replace(/ /g, " ")
                .replace(/[ä|à|á|æ|ã]/gi, "a")
                .replace(/[ó|ö|ô|ò|œ]/gi, "o")
                .replace(/[ü|ú|ű|û|ù]/gi, "u")
                .replace(/[í|î|ï|ī]/gi, "i" ).toLowerCase().trim();
            }
        });
    }

    // hide unavailable options
    function shuffleToggleFilter() {
        $(".js-shuffle-selector option").each(function () {
            var filter = $(this).val(),
                $selector = $(this);
            $selector.show();

            if (filter != "") {
                if (!$(".js-shuffle-item" + filter + ":visible").length) {
                    $selector.hide();
                }
            }
        });
    }
    // init Function to hide unavailable options
    shuffleToggleFilter();



    /// * * * * * * * * * * * * * * * * * * * * * * * * *
    // * load more news and events
    // *
    // *

    var $news = $(".js-news-wrapper"),
        $newsPagination = $(".js-news-pagination"),
        $newsButton = $(".js-news-load-button");

        $newsButton.click(function () {
        var url = $newsPagination.find("a.next").attr("href");
        var $nextLink = $newsPagination.find("a.next").removeClass("next").next("a").addClass("next");

        if (!$newsPagination.find("a.next").length) {
            $newsButton.fadeOut();
        }

        //mixer.destroy();

        $.get(url).done(function (data) {
            //var newItems = $(data).find(".js-news-wrapper .js-news");
            //console.log(newItems);
            //$projects.append(newItems);

            $(data).find(".js-news-wrapper .js-news").appendTo($news);

            //var containerEl = document.querySelector('.shuffle__list');
            //var mixer = mixitup(containerEl, {
            //    multifilter: {
            //        enable: true
            //    },
            //    animation: {
            //        effects: 'fade translateZ(-100px)'
            //   },
            //    callbacks: {
            //        onMixStart: function(state, futureState) {
            //             $('.lazy').lazy({ bind: "event", delay: 0 });
            //        }
            //    }
            //});
            $("button.control").trigger("click");
            shuffleToggleFilter();
            $('.lazy').lazy({ bind: "event", delay: 0 });
        });
    });

    // mark next navigation page for load more button on init
    $newsPagination.find("a.active").next("a").addClass("next");

    // hide button if not enough news on init
    if ($newsPagination.find("a").length <= 1) {
        $newsButton.hide();
    }



    /// * * * * * * * * * * * * * * * * * * * * * * * * *
    // * fancy box
    // *
    // *

    $('[data-fancybox="teamgallery"]').fancybox({
        image: {
            preload: true
        }
        /*,
        beforeLoad: function (instance, current) {
            //which element was clicked
            var eleId = current.src;
            console.log("eleId: " + eleId);
            //path to the image of the active element
            var source = $(eleId).find(".fb-portrait__image img").attr("data-src");
            console.log("source: " + source);

            //set value of data-src to src and remove data-src
            var img = $(eleId).find(".lazy").attr("src", source).removeAttr("data-src");
            console.log("img: " + img);
        }
        */
    });
    $('.fb-portrait').hide();



    /// * * * * * * * * * * * * * * * * * * * * * * * * *
    // * lazy load
    // *
    // *

    $('.lazy').lazy({
        visibleOnly: true
    });



    /// * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hover Upload button
    // *
    // *

    $(function () {
        $(".formular__upload").mousemove(function (e) {
            var offL, offR, inpStart
            offL = $(this).offset().left;
            offT = $(this).offset().top;
            aaa = $(this).find("input").width();
            $(this).find("input").css({
                left: e.pageX - aaa - 30,
                top: e.pageY - offT - 10
            })
        });
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * newsSlider
    // *
    // *

    // var $newsboxSlider = $(".newsbox__slider");
    // if ($newsboxSlider.length) {
    //     $newsboxSlider.bxSlider({
    //         mode: 'fade',
    //         touchEnabled: false,
    //         captions: true,
    //         pager: ($(".newsbox__slider .newsbox__slide").length > 1) ? true : false,
    //         controls: false,
    //         auto: true,
    //         speed: 800,
    //         pause: 10000,
    //         autoHover: true
    //     });
    // }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * show and hide newsbox
    // *
	// *

	$(window).scroll(function () {
		if ($(this).scrollTop() > 10) {
            $(".newsbox").addClass("close");
            $(".newsbox").removeClass("open");
        } else {
            $(".newsbox").addClass("open");
			$(".newsbox").removeClass("close");
        }
    });
	
	$(".newsbox__btn").click(function(){
		if($(".newsbox").hasClass("close") ) {
			$(".newsbox").removeClass("close");
			$(".newsbox").addClass("open");
		} else {
			$(".newsbox").removeClass("open");
			$(".newsbox").addClass("close");
		}
		return false;
	});

    

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * marquee newsticker
    // *
	// *
    
    var $window = $(window);
    
    function checkWidth() {
        var windowsize = $window.width();
        if (windowsize < 1024) {
            $('.marquee__inner').marquee({
                duration: 5000,
                gap: 150,
                delayBeforeStart: 0,
                direction: 'left',
                duplicated: false,
                pauseOnHover: true,
            });
        }

        if (windowsize > 1024) {
            $('.marquee__inner').marquee({
                duration: 15000,
                gap: 150,
                delayBeforeStart: 0,
                direction: 'left',
                duplicated: false,
                pauseOnHover: true,
            });
        }
    }
    checkWidth();

    $(document).ready(function () {
        var $tabs = $(".tabs__box");
        if ($tabs.length) {
            $tabs.responsiveTabs({
                rotate: false,
                collapsible: false,
                setHash: true,
                active: 0,
                scrollToAccordionOnLoad: true
            });
        }
    });
});
